import { useContext, useEffect, useRef, useState } from "react";
import { BsList } from "react-icons/bs";
import useOutsideClick from "../../hooks/useOutsideClick";
import { EnquiryMenuProps } from "../../interfaces/menu";
import { EnquiryMenuItems } from ".";
import { EnquiryGridSelectionContext } from "../../contexts/enquiry-grid-selection.context";
import { RootState } from "../../state/store";
import { useSelector } from "react-redux";
import Statuses from "../../interfaces/Statuses";
import { orderIdsByActiveList } from "../../Logic/Enquiries/exportSelection";
import { getActiveListEnquiries } from "../../utilities/localStore/calls";

interface EnquiryBurgerMenuProps extends EnquiryMenuProps {
    // Re-order enquiryIds into grid display order (the session's active list) on every render of this
    // menu, including when it opens, so a column re-sort since the caller last rendered is honoured.
    orderByActiveList?: boolean;
}

export function EnquiryBurgerMenu({ enquiryIds: passedIds, orderByActiveList }: EnquiryBurgerMenuProps) {
    const enquiryIds = orderByActiveList ? orderIdsByActiveList(getActiveListEnquiries(), passedIds) : passedIds;
    const [barMenuActive, setBarMenuActive] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    useOutsideClick(menuRef, () => setBarMenuActive(false));
    const { selectionProperties } = useContext(EnquiryGridSelectionContext);
    const enquiriesCache = useSelector((state: RootState) => state.EnquiryCache.data);
    const [multiSelectEnquiriesInUserProcessing, setmultiSelectEnquiriesInUserProcessing] = useState(false);
    useEffect(() => {
        if (!selectionProperties.multiSelect) {
            setmultiSelectEnquiriesInUserProcessing(false); //if i dont set this then the selection is remembered when we go between multi and single instead of being reset
            return;
        }
        if (enquiriesCache.find(x => enquiryIds.includes(x.id) && x.status == Statuses.Processing.ID)) {
            setmultiSelectEnquiriesInUserProcessing(true);
        } else {
            setmultiSelectEnquiriesInUserProcessing(false);
        }
    });

    return (
        <>
            <div
                className={`g-dropdown-basic${barMenuActive ? "-selected" : ""}`}
                ref={menuRef}
                title="Menu"
            >
                <div
                    tabIndex={0}
                    onClick={() => setBarMenuActive(b => !b)}
                    className={` icon-button${barMenuActive ? "-selected" : ""} `}
                >
                    <BsList style={{ width: "14px", height: "14px" }} />
                </div>
                {barMenuActive && (
                    <div style={{ position: "absolute", top: 30, left: -188 }}>
                        <EnquiryMenuItems
                            onHide={() => setBarMenuActive(false)}
                            enquiryIds={enquiryIds}
                            menuStyle={"menu"}
                            exportOnly={multiSelectEnquiriesInUserProcessing}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
